export interface SisterOrganization {
  name: string
  location: string
  focus: string
  focusEs: string
  description: string
  descriptionEs: string
  url?: string
  /** [latitude, longitude] of the organization's primary base */
  coords: [number, number]
  /** Hex accent used for the map pin and the card's top stripe */
  accent: string
}

export const SISTER_ORGANIZATIONS: SisterOrganization[] = [
  {
    name: 'Federation of Honduran Organizations in New York',
    location: 'New York, NY',
    focus: 'Civic & Community Advocacy',
    focusEs: 'Defensa Cívica y Comunitaria',
    description:
      'A long-standing federation uniting Honduran community organizations across the New York metropolitan area, coordinating civic advocacy, cultural programming, and mutual support among member groups.',
    descriptionEs:
      'Una federación de larga trayectoria que une a organizaciones comunitarias hondureñas en el área metropolitana de Nueva York, coordinando defensa cívica, programación cultural y apoyo mutuo entre grupos miembros.',
    coords: [40.7128, -74.006],
    accent: '#003F87',
  },
  {
    name: 'Bronx World Film',
    location: 'The Bronx, NY',
    focus: 'Arts, Film & Culture',
    focusEs: 'Artes, Cine y Cultura',
    description:
      'A nonprofit using independent cinema and the arts as vehicles for cultural exchange and human development, elevating Honduran and Central American voices in New York and beyond.',
    descriptionEs:
      'Una organización sin fines de lucro que utiliza el cine independiente y las artes como vehículos de intercambio cultural y desarrollo humano, elevando las voces hondureñas y centroamericanas en Nueva York y más allá.',
    url: 'http://www.bronxworldfilm.org/',
    coords: [40.8448, -73.8648],
    accent: '#4A90D9',
  },
  {
    name: 'The Hope Center for Wellness',
    location: 'Washington, D.C.',
    focus: 'Mental Health & Wellness',
    focusEs: 'Salud Mental y Bienestar',
    description:
      'An award-winning mental health agency providing culturally responsive clinical care, therapy, and regional and national initiatives serving Latino and immigrant families.',
    descriptionEs:
      'Una agencia de salud mental galardonada que brinda atención clínica culturalmente receptiva, terapia e iniciativas regionales y nacionales al servicio de familias latinas e inmigrantes.',
    url: 'http://hopecenterforwellness.com/',
    coords: [38.9072, -77.0369],
    accent: '#1565C0',
  },
  {
    name: 'Students Helping Honduras',
    location: 'Fredericksburg, VA · Nationwide',
    focus: 'Education & Youth Development',
    focusEs: 'Educación y Desarrollo Juvenil',
    description:
      'Mobilizes students across the United States to build schools and educational infrastructure in Honduras, connecting young leaders on both sides of the diaspora.',
    descriptionEs:
      'Moviliza a estudiantes en todo Estados Unidos para construir escuelas e infraestructura educativa en Honduras, conectando a jóvenes líderes en ambos lados de la diáspora.',
    url: 'https://studentshelpinghonduras.org/',
    coords: [38.3032, -77.4605],
    accent: '#4A90D9',
  },
  {
    name: 'Educate 2 Envision',
    location: 'Honduras · U.S. Partners',
    focus: 'Rural Education',
    focusEs: 'Educación Rural',
    description:
      'Reimagines rural education in Honduras through community-led schooling, leadership development, and long-term investment in students who become local changemakers.',
    descriptionEs:
      'Reimagina la educación rural en Honduras a través de escuelas lideradas por la comunidad, desarrollo de liderazgo e inversión a largo plazo en estudiantes que se convierten en agentes de cambio locales.',
    url: 'https://www.educate2envision.org/',
    coords: [15.5, -87.9],
    accent: '#4A90D9',
  },
  {
    name: 'CRC — We Care We Share',
    location: 'New Orleans, LA',
    focus: 'Community Services',
    focusEs: 'Servicios Comunitarios',
    description:
      'A community resource organization serving immigrant and underserved families along the Gulf Coast with direct assistance, referrals, and neighborhood programming.',
    descriptionEs:
      'Una organización de recursos comunitarios que sirve a familias inmigrantes y desatendidas a lo largo de la Costa del Golfo con asistencia directa, referencias y programación vecinal.',
    url: 'https://www.crcwecareweshare.org/',
    coords: [29.9511, -90.0715],
    accent: '#1565C0',
  },
  {
    name: 'Honduras Global',
    location: 'International · Honduras',
    focus: 'Diaspora Knowledge Network',
    focusEs: 'Red de Conocimiento de la Diáspora',
    description:
      'An international diaspora knowledge network connecting Honduran professionals abroad with institutions at home, channeling expertise toward innovation, education, and development.',
    descriptionEs:
      'Una red internacional de conocimiento de la diáspora que conecta a profesionales hondureños en el exterior con instituciones en el país, canalizando experiencia hacia la innovación, la educación y el desarrollo.',
    coords: [14.0723, -87.1921],
    accent: '#003F87',
  },
]
